import { DeleteOutlined, SaveOutlined, SettingOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Modal, Row, Tooltip, Typography } from "antd";
import { useMutation } from "../../../../../hooks";
import { useEffect, useState } from "react";

export const TechnologiesCatalog = ({ technologies, onSuccessfullyRequest, notificationAPI }) => {
    const [open, setOpen] = useState(false);



    const config = {
        url: "/catalogtechnology",
        onSuccess: () => {
            notificationAPI.success({
                message: 'La operacion se realizó correctamente.',
                duration: 3,
                className: "custom-notification-bg"
            });
            onSuccessfullyRequest();
        },
        onError: (err) => {
            notificationAPI.error({
                message: "Opps, hubo un error al llevar a cabo la operación.",
                description: err.message,
                className: "custom-notification-bg",
                duration: 3,
            });
        }
    }
    const { loading: editTechLoading, executeMutation: editTech } = useMutation({
        method: "PUT",
        ...config
    })

    const { loading: deleteLoading, executeMutation: deleteTech } = useMutation({
        method: "DELETE",
        ...config
    })

    const { loading: posting, error: postError, executeMutation: postTech } = useMutation({
        method: "POST",
        ...config
    })



    return (
        <>
            <Tooltip
                title="Configurar tecnologías"
                placement="top"
            >
                <Button
                    icon={<SettingOutlined />}
                    type="default"
                    size="large"
                    onClick={() => setOpen(true)}
                />
            </Tooltip>
            <Modal
                open={open}
                onCancel={() => setOpen(false)}
                title={
                    <Typography.Title level={4} style={{ margin: 0, padding: "10px", color: "#ffff" }}>
                        Catálogo de Tecnologías
                    </Typography.Title>}
                footer={null}
                bodyProps={{
                    style: {
                        maxHeight: "80vh",
                        overflowY: "auto",
                    }
                }}
                centered
                destroyOnClose
            >
                <AddTechnologySection post={postTech} loading={posting} error={postError !== null} />
                {technologies.map((tech) => (
                    <TechnologyItem
                        key={tech.id}
                        tech={tech}
                        onSave={editTech}
                        saving={editTechLoading}
                        onDelete={() => {
                            deleteTech(tech);
                        }}
                        deleting={deleteLoading}
                    />
                ))}
            </Modal >
        </>
    )
}

const TechnologyItem = ({ tech, onSave, onDelete, saving, deleting }) => {
    const [value, setValue] = useState(tech.name);
    return (
        <Row
            gutter={8}
            style={{
                margin: "8px 16px"
            }}
        >
            <Col flex="auto">
                <Input value={value} onChange={(e) => setValue(e.target.value)} />
            </Col>
            <Col flex="none">
                <Button
                    icon={<SaveOutlined />}
                    type="primary"
                    style={value === tech.name ? {} : {
                        backgroundColor: "var(--color-secondary)",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.15)"
                    }}
                    size="large"
                    disabled={value === tech.name}
                    onClick={() => onSave({ id: tech.id, name: value })}
                    loading={value !== tech.name && saving}
                />
            </Col>
            <Col flex="none">
                <Button
                    icon={<DeleteOutlined />}
                    type="primary"
                    danger
                    size="large"
                    loading={deleting}
                    onClick={onDelete}
                />
            </Col>
        </Row>
    )
}

const AddTechnologySection = ({ post, loading, error }) => {
    const [agregarOpen, setAgregarOpen] = useState(false);
    const [form] = Form.useForm();
    useEffect(() => {
        if (!loading && !error) {
            setAgregarOpen(false);
            form.resetFields()
        }
    }, [loading, error, form])
    return (
        <>
            <Row
                gutter={8}
                style={{ margin: "8px 16px" }}
            >
                {
                    agregarOpen ?
                        <>
                            <Col flex="auto">
                                <Form
                                    onFinish={async () => {
                                        const values = await form.validateFields();
                                        post({ name: values.name })
                                    }}
                                    form={form}
                                >
                                    <Form.Item
                                        name="name"
                                        rules={[{ required: true, message: "Requerido" }]}
                                    >
                                        <Input placeholder="Nombre de la tecnología" />
                                    </Form.Item>

                                </Form>
                            </Col>
                            <Col flex="none">
                                <Button
                                    icon={<SaveOutlined />}
                                    type="primary"
                                    style={{
                                        backgroundColor: "var(--color-secondary)",
                                        boxShadow: "0 4px 15px rgba(0,0,0,0.15)"
                                    }}
                                    size="large"
                                    onClick={() => form.submit()}
                                    loading={loading}
                                />
                            </Col>
                            <Col flex="none">
                                <Button
                                    icon={<DeleteOutlined />}
                                    type="primary"
                                    danger
                                    size="large"
                                    onClick={() => {
                                        setAgregarOpen(false);
                                        form.resetFields();
                                    }}
                                />
                            </Col>
                        </>

                        :
                        <Col flex="auto">
                            <Button
                                type="dashed"
                                size="large"
                                onClick={() => { setAgregarOpen(true) }}
                                block
                            >
                                Agregar tecnología
                            </Button>
                        </Col>
                }
            </Row>

        </>
    );

}